import _ from 'lodash';
import React from 'react';

import {
  Box,
  Pagination,
  styled,
  Typography
} from '@mui/material';



const ContainerBox = styled(Box)({
  display: 'flex',
  alignItems: 'center'
});

export interface IStandardPaginationControlProps {
  page: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;

  onPageChanged: (pageNumber: number) => void;
}

export const StandardPaginationControl: React.FC<IStandardPaginationControlProps> = props => {
  const [fromCount, toCount] = React.useMemo(
    () => [
      props.pageSize * props.page + 1,
      _.clamp(props.pageSize * (props.page + 1), 0, props.rowCount)
    ],
    [props]
  );

  return (
    <ContainerBox>
      <Typography>
        {fromCount} - {toCount} of {props.rowCount}
      </Typography>

      <Pagination
        style={{ display: 'flex' }}
        page={props.page + 1}
        count={props.pageCount}
        onChange={(event, value) => {
          props.onPageChanged(value - 1);
        }}
      />
    </ContainerBox>
  );
};
